


















import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import * as Helper from '../../helpers'

@Component
export default class RenderLabelValue extends Vue {
  @Prop({type: String}) label!: string
  @Prop({type: [String, Number]}) value!: string
  @Prop({type: String}) labelClass!: string
  @Prop({type: String}) tagClass!: string
}
